/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('dropdown-chip', {
    template: `<label data-bind="visible: visible, html: text, click: remove"></label>`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new DropdownChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function DropdownChipViewModel(params, componentInfo) {
  var self = this;

  var initialText = params.text;

  self.text = ko.pureComputed(function () {
    params.data();
    var select = document.getElementById(params.for);
    var text = select.options[select.selectedIndex].text;

    return initialText + ': ' + text;
  }, self);

  self.visible = ko.pureComputed(function () {
    return !!params.data();
  }, self);

  self.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');
    params.data(null);
    $form.trigger('update');
  };
}
